'use client';

import { useWallet, WalletContextState } from '@solana/wallet-adapter-react';

import { useMemo } from 'react';

/**
 * WARNING: For wallet management only (connect, disconnect, select, sync).
 * Do NOT use publicKey, connected, or signing methods from this hook — they won't work for Privy Native accounts.
 * Use useCurrentWalletAdapter() instead for feature/UI code.
 **/
type WalletManagementContext = Omit<
	WalletContextState,
	| 'publicKey'
	| 'connected'
	| 'sendTransaction'
	| 'signTransaction'
	| 'signAllTransactions'
	| 'signMessage'
	| 'signIn'
>;

const useWalletContext = (): WalletManagementContext => {
	const walletContext_ = useWallet();

	const walletContext = useMemo(() => {
		return {
			wallets: walletContext_.wallets,
			wallet: walletContext_.wallet,
			adapter: walletContext_.wallet?.adapter,
			select: walletContext_.select,
			disconnect: walletContext_.disconnect,
			autoConnect: walletContext_.autoConnect,
			connecting: walletContext_.connecting,
			disconnecting: walletContext_.disconnecting,
			connect: walletContext_.connect,
		};
	}, [walletContext_, walletContext_?.publicKey?.toBase58() ?? '']);

	return walletContext;
};

export default useWalletContext;
